import "./app_fest.sass";

import $ from "jquery"
import "bootstrap/dist/js/bootstrap"
import Sticky from "sticky-js"

import "./components/posts"
import "./components/forms"
import "./components/media"
import "./components/index"
import "./components/countdown"
import "./components/programs"
import "./components/sponsorSlider"


$(function () {

	const $headerLogo = $('.headerLogo');
	if ($headerLogo.length) {
		const $animated = $headerLogo.find('a.animated');
		const $notAnimated = $headerLogo.find('a:not(.animated)');
		//$animated.removeClass('d-none');
		//$notAnimated.addClass('d-none');
	}

});



